<template>
    <a-entity
        geometry="primitive: rounded-plane; width: 0.3; height: 0.3" material="color: #001034;"
        push-mesh-backwards="distance: 0.02"
    >
        <a-box color="tomato" depth="0.2" height="0.2" width="0.2"></a-box>
    </a-entity>
</template>

<script>
export default {
    name: "EmptyHomePanel",
}
</script>

<style scoped>
</style>